module.exports = __webpack_public_path__ + "static/media/magdalena@2x.85601b00.jpg";